import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../../components/LoaderScreen";
import Swal from "sweetalert2";
import request from "../../../../Helpers/API";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { CargarConvenioModal } from "../Modal/CargarConvenioModal";
import { DescargarConvenioModal } from "../Modal/DescargarConvenioModal";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import FiltroConveniosRealizados from "../Components/FiltroConveniosRealizados";
import { useBox } from "../../ReporteCobranza/Helper/useBox";
import { GetKey } from "../../ReporteCobranza/Actions/GetContainer";
import RegistrarGestionComentarioModal from "../Modal/RegistrarGestionComentarioModal";

export const ListadoComentariosClienteScreen = () => {
    const history = useHistory();
    const { state } = useLocation();
    const idcliente = state.idcliente;
    const [gestiones, setGestiones] = useState([])
    const [openModal, setOpenModal] = useState(false)
    const [modalDescarga, setModalDescarga] = useState(false);
    const [gestion, setGestion] = useState({
        mediocontacto: "",
        gestion: "M",
        objecion: ""
    });

    const [folio, setFolio] = useState('')
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [openRegistrarComentarioModal, setOpenRegistrarComentarioModal] = useState(false);

    const handleOpenRegistrarComentarioModal = () => {
        setOpenRegistrarComentarioModal(true);
    };
    const handleCloseRegistrarComentarioModal = () => {
        setOpenRegistrarComentarioModal(false);
    };

    const handleOpenModal = (folio) => {
        setOpenModal(true);
        setFolio(folio)
    }

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const abrirModalDescarga = (folio) => {
        setModalDescarga(true);
        setFolio(folio)
    };

    const cerrarModalDescarga = () => {
        setModalDescarga(false);
    };


    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        onExecute(idcliente);
        setLoader({ ...loader, mostrar: false });
    }, [openRegistrarComentarioModal]);

    const onExecute = (idcliente) => {
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `ListadoComentariosGestionCliente/ListadoCliente?cliente=${idcliente}`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setGestiones(result)
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };
    // console.log(boxstate)

    // const onGeneraExcel = (ejercicio, periodo, responsable) => {
    //     var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    //     var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    //     if (sucursales === undefined || sucursales === null || sucursales === "") {
    //         sucursales = "0";
    //     }
    //     if (adr === undefined || adr === null || adr === "") {
    //         adr = "0";
    //     }
    //     setLoader({ ...loader, mostrar: true });
    //     request
    //         .get(`ListadoGestionesRealizadasComentario/ImprimirExcel?ejercicio=${ejercicio}&periodo=${periodo}&responsable=${responsable}&sucursal=${sucursales}&adr=${adr}`)
    //         .then(({ documento, filename }) => {
    //             const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
    //             const downloadLink = document.createElement("a");
    //             const fileName = `${filename}.xlsx`;
    //             downloadLink.href = linkSource;
    //             downloadLink.download = fileName;
    //             downloadLink.click();
    //             setLoader({ ...loader, mostrar: false });
    //         })
    //         .catch((error) => {
    //             setLoader({ ...loader, mostrar: false });
    //             Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
    //         });
    // };

    // const onGeneraPDF = (ejercicio, periodo, responsable) => {
    //     var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    //     var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    //     if (sucursales === undefined || sucursales === null || sucursales === "") {
    //         sucursales = "0";
    //     }
    //     if (adr === undefined || adr === null || adr === "") {
    //         adr = "0";
    //     }
    //     setLoader({ ...loader, mostrar: true });
    //     request
    //         .get(`ListadoGestionesRealizadasComentario/ImprimirPDF?ejercicio=${ejercicio}&periodo=${periodo}&responsable=${responsable}&sucursal=${sucursales}&adr=${adr}`)
    //         .then((result) => {
    //             setLoader({ ...loader, mostrar: false });
    //             const linkSource = `data:application/pdf;base64, ${result.documento}`;
    //             const downloadLink = document.createElement("a");
    //             const fileName = `${result.nombredocumento}.${result.extension}`;
    //             downloadLink.href = linkSource;
    //             downloadLink.download = fileName;
    //             downloadLink.click();
    //         })
    //         .catch((error) => {
    //             setLoader({ ...loader, mostrar: false });
    //             Swal.fire("Clientes", JSON.stringify(error), "error");
    //         });
    // };


    return (
        <PlantillaScreen
            titulo={`LISTADO DE COMENTARIOS`}
            className={"convenio-pago-main-screen"}
            className_main={1}
        >
            <div className="listado-convenios-actions">
                <div
                    className="listado-convenios-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="buttons">
                    <button className="excel"
                        onClick={() => handleOpenRegistrarComentarioModal()}
                    >
                        <i className=" icon-file-excel" /> Agregar
                    </button>
                    {/* <button className="excel"
                        onClick={() => onGeneraExcel(boxstate.ejercicio, boxstate.periodo, boxstate.responsable)}
                    >
                        <i className=" icon-file-excel" /> Excel
                    </button>
                    <button className="PDF"
                        onClick={() =>
                            onGeneraPDF(boxstate.ejercicio, boxstate.periodo, boxstate.responsable)
                        }
                        style={{ backgroundColor: '#940404' }}>
                        PDF
                    </button> */}
                </div>
            </div>
            <div className="listado-convenios-cliente">
                <LoaderScreen loader={loader} />
                <div className="listado-convenios-cliente-header">
                    <div className="listado-convenios-cliente-header-title">
                        <FormatListNumberedIcon /> Listado de Gestiones Realizadas
                    </div>
                    <div className="contador-gestiones-encontrados">
                        Gestiones Encontradas: {gestiones.length}
                    </div>
                </div>
                <div className="listado-convenios-cliente-container scroll-4">
                    <table>
                        <thead>
                            <tr>
                                {/* <th>No. Gestión</th> */}
                                <th>
                                    Cliente
                                </th>
                                <th>
                                    <div>Responsable de Cobranza</div>
                                </th>
                                <th>
                                    <div>Volver a Contactar</div>
                                </th>
                                <th>
                                    <div>Fecha para Contactar</div>
                                </th>
                                <th>
                                    <div>Comentario</div>
                                </th>
                                <th>
                                    <div>Objeción</div>
                                </th>
                                <th>
                                    <div>Saldo</div>
                                </th>
                                <th>
                                    <div>Interés Pactado</div>
                                </th>
                                <th>
                                    <div>Interés Moratorio</div>
                                </th>
                                <th>
                                    <div>Total</div>
                                </th>
                                <th>
                                    <div>Fecha de Gestión</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {gestiones.map((ge) => (
                                <tr>
                                    {/* <td className="ta-center">{ge.idgestion}</td> */}
                                    <td className="ta-left">{ge.razonSocial}</td>
                                    <td className="ta-left">{ge.responsable}</td>
                                    <td className="ta-center">{ge.volvercontactar}</td>
                                    <td className="ta-center ta-fecha">{ge.fechavolvercontactar ? ge.fechavolvercontactar.split('T')[0] : '-'}</td>
                                    <td className="ta-left ta-comentario">{ge.comentarios}</td>
                                    <td className="ta-left">{ge.objecion}</td>
                                    <td className="ta-right">{FormatMoney(ge.saldo)}</td>
                                    <td className="ta-right">{FormatMoney(ge.interespactado)}</td>
                                    <td className="ta-right">{FormatMoney(ge.moratorios)}</td>
                                    <td className="ta-right">{FormatMoney(ge.total)}</td>
                                    <td className="ta-center ta-fecha">{ge.createdate.split('T')[0]}</td>
                                    {/* <td>
                                        <div className="convenio-pago-acciones-listado">
                                            <div className="boton-descargar-convenio-pago-pdf" onClick={() => abrirModalDescarga(vc.folio)}><CloudDownloadIcon /> Descargar </div>
                                            <div className="boton-subir-evidencia-convenio-pago" onClick={() => handleOpenModal(vc.folio)}><CloudUploadIcon />Cargar</div>
                                        </div>
                                    </td> */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </div>
            <RegistrarGestionComentarioModal
                open={openRegistrarComentarioModal}
                onClose={handleCloseRegistrarComentarioModal}
                // onRegresar={handleRegresarDesdeComentario}
                facturasSeleccionadas={state.facturasSeleccionadas}
                mediocontacto={gestion.mediocontacto}
                gestion={gestion.gestion}
                objecion={gestion.objecion}
                saldo={state.saldo}
                moratorios={state.moratorios}
                interespactado={state.interespactado}
                total={state.total}
                responsable={state.responsable}
                idcliente={idcliente}
            />
        </PlantillaScreen>
    );
};
